import { render, staticRenderFns } from "./ChangeColorModal.vue?vue&type=template&id=0698bc80&scoped=true&"
import script from "./ChangeColorModal.vue?vue&type=script&lang=js&"
export * from "./ChangeColorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0698bc80",
  null
  
)

export default component.exports